module.exports = __webpack_public_path__ + "static/html-element-advanced_1-b939e2de928106ee84b6b77d64cb9039.jpg";